import { render, staticRenderFns } from "./CartInfoCompact.vue?vue&type=template&id=10b99280&scoped=true"
import script from "./CartInfoCompact.vue?vue&type=script&lang=js"
export * from "./CartInfoCompact.vue?vue&type=script&lang=js"
import style0 from "./CartInfoCompact.vue?vue&type=style&index=0&id=10b99280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b99280",
  null
  
)

export default component.exports